import React, { useMemo } from 'react'
import CustomDataTable from '../../shared/CustomDataTable'

// Turn a month label like "Jan/2024" into a safe CSS/object key "Jan_2024"
const sanitizeKey = (str) => str.replace(/[^a-zA-Z0-9_]/g, '_')

const HistoryTable = ({ headers, data }) => {
  const rowHeaders = Object.keys(data || {})

  // Dynamic columns: name | ...months | total
  const columns = useMemo(() => {
    const monthCols = headers.map((header) => ({
      key: sanitizeKey(header),
      label: header,
      sortable: false,
      align: 'left',
      totals: true,
    }))

    return [
      {
        key: 'name',
        label: 'Descrição',
        sortable: false,
        totalsLabel: 'Total',
      },
      ...monthCols,
      {
        key: 'total',
        label: 'Total por Unidade',
        sortable: false,
        align: 'left',
        totals: true,
      },
    ]
  }, [headers])

  // Flatten the nested-object data into an array for CustomDataTable
  const tableData = useMemo(() => {
    return rowHeaders.map((rowHeader) => {
      const row = data[rowHeader]
      const monthValues = headers.map((h) => row[h] || 0)
      const total = monthValues.reduce((a, b) => a + b, 0)

      const item = { name: rowHeader, total }
      headers.forEach((h, i) => {
        item[sanitizeKey(h)] = monthValues[i]
      })
      return item
    })
  }, [data, headers, rowHeaders])

  return (
    <CustomDataTable
      className="history-table"
      columns={columns}
      data={tableData}
      rowKey={(item, index) => item.name || index}
      emptyMessage="Sem histórico disponível."
    />
  )
}

export default HistoryTable